export const projectsData = [
  {
    id: 4,
    title: 'MIN-AH LOG',
    description: '현재 진행 중인 포트폴리오 블로그 프로젝트입니다.',
    image: '/assets/minah_log/minahlog_logo.png',
    period: '2026.06 - 현재 (진행 중)',
    date: '2026.06',
    duration: '진행 중',
    members: '개인 프로젝트',
    github: 'https://github.com/01MINAH/minah-log-frontend',
    // retrospective: 'https://velog.io/@minah_94/posts',
    teamName: '개인 프로젝트',
    detailedDescription: 'React를 기반으로 한 개인 포트폴리오 블로그 개발 프로젝트입니다.',
    contribution: '• 포트폴리오 기획 및 디자인\n• React 컴포넌트 개발',
    techStack: ['React', 'JavaScript', 'CSS'],
    markdownPath: '/content/projects/minah-log.md'
  },
  {
    id: 2,
    title: 'PopFlix',
    description: '[LG유플러스] 유레카 SW 교육과정에서 진행하는 경진대회 ‘융합’프로젝트 입니다. 영화 리뷰 서비스를 제공합니다.',
    image: '/assets/popflix/popflix메인화면3.png',
    period: '2024.11 - 2024.12',
    date: '2024.11',
    duration: '약 1개월 소요',
    members: 'Frontend 4명, Backend 3명',
    github: 'https://github.com/orgs/URECA-TEAM-5/repositories',
    // retrospective: 'https://velog.io/@minah_94/posts',
    teamName: 'PopFlix 팀',
    detailedDescription: '영화 리뷰 서비스를 제공하는 융합 프로젝트입니다.',
    contribution: '• 상세 내용은 여기에 작성해 주세요\n• 노션 하위 페이지에 있는 내용을 추가하시면 됩니다.',
    techStack: ['Spring Boot', 'React', 'MySQL'],
    markdownPath: '/content/projects/popflix.md'
  },
  {
    id: 3,
    title: '꿈틀',
    description: '우리 아이의 꿈의 틀을 잡아주는 맞춤형 아동 성향 진단 및 도서 추천 서비스 LG유플러스 유레카 SW 교육과정의 경진대회 종합 프로젝트 로 진행한 AI 기반 아동 성향 분석 및 도서 추천 플랫폼입니다.',
    image: 'assets/ggumtle/mainpage.png',
    period: '2024.10 - 2024.11',
    date: '2024.10',
    duration: '약 1개월 소요',
    members: '팀 프로젝트',
    github: 'https://github.com/KKUMTEUL',
    // retrospective: 'https://velog.io/@minah_94/posts',
    teamName: '꿈틀 팀',
    detailedDescription: '아이들의 성향을 진단하고 그에 맞는 도서를 추천해주는 맞춤형 서비스입니다.',
    contribution: '• 상세 내용은 여기에 작성해 주세요',
    techStack: ['React', 'Node.js', 'Express', 'MySQL'],
    markdownPath: '/content/projects/ggumtle.md'
  },
  {
    id: 1,
    title: '대기만성',
    description: '[소프트웨어학과 경진대회] 에서 진행한 ‘자격증을 준비중인 학습자들을 위한 효율적인 학습 사이트’ 입니다.',
    image: '/assets/late_bloomer/대기만성_logo.png',
    period: '2022.06 - 2022.12',
    date: '2022.06',
    duration: '약 6개월 소요',
    members: '팀 프로젝트 (4명)',
    // github: 'https://github.com/01MINAH',
    // retrospective: 'https://velog.io/@minah_94/posts',
    teamName: '대기만성',
    detailedDescription: '각 자격증에 알맞는 기출문제들, 강좌들을 모아두었고, 학습자를 위한 문제 추천 서비스도 제공합니다.',
    contribution: '• OCR\n• Crawling (10,000건 이상 데이터 수집)\n• DB 환경 구축 (도메인 별 테이블 분리)\n• MySQL DB 관리\n• ERD 다이어그램 제작 (기여도 85+%)',
    techStack: ['Python', 'Django', 'MySQL'],
    markdownPath: '/content/projects/late-bloomer.md'
  }
];
